import styled from "styled-components";

const Grid = styled.div`
  display: flex;
  align-items: ${props =>
    props.valign === "center"
      ? "center"
      : props.valign === "expand"
        ? "strech"
        : "flex-start"};
  justify-content: ${props =>
    props.align === "spacing" ? "space-between" : "flex-start"};
  flex-wrap: ${props => (props.wrap ? "wrap" : "")};

  & > * {
    width: 100%;
  }
`;

export default Grid;



// WEBPACK FOOTER //
// ./src/UI/Layout/Grid.js